import React, { useState } from "react";
import Header from "../../../../components/commonComponents/modals/Header";
import { Dropdown, Menu, Popover } from "antd";
import { ICONS } from "../../../../assets/icons";
import dayjs from "dayjs";
import {
  inboxNotes,
} from "../../api/Api";
import { replaceFormating } from "../../helper";
import { useNote } from "../../providers/NoteContext";

const NoteCard = ({ note, onEdit, onDelete, chatToggle, setChatToggle }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const { setNoteContent } = useNote();


  const handleMenuClick = ({ key }) => {
    if (key === 'edit') {
      // onEdit(note);
      setNoteContent(note);
      setChatToggle(false);
    } else if (key === 'delete') {
      onDelete(note);
    }
    setMenuVisible(false);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="edit" icon={<div className="flex items-center"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg></div>}>
        Edit
      </Menu.Item>
      <Menu.Item key="delete" icon={<div className="flex items-center text-red-500"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6H5H21" stroke="#FF4D4F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#FF4D4F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg></div>}>
        <span className="text-red-500">Delete</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="bg-[#FFEC9A] rounded-lg p-4 mb-4 relative">
      <div className="flex justify-between">
        <div className="flex-1 pr-2">
          <p className="text-gray-800 text-sm mb-2">
            <div dangerouslySetInnerHTML={{ __html: replaceFormating(note.content) }} />
          </p>
        </div>
        <div className="cursor-pointer" onClick={() => setMenuVisible(!menuVisible)}>
          <Dropdown 
            overlay={menu} 
            trigger={['click']} 
            visible={menuVisible}
            onVisibleChange={setMenuVisible}
            placement="bottomRight"
          >
            <div className="p-1">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </Dropdown>
        </div>
      </div>
      <div className="text-gray-600 font12px-400 text-sm mt-2">
        {note.note_created_by} {dayjs(note?.created_at).format(
                                          "hh:mm A DD/MMM/YYYY"
                                        )}
      </div>
    </div>
  );
};

const NotesSection = ({ 
  setIsSideNavOpen, 
  notes, 
  setIsSideNavOpenIcon1, 
  setIsSideNavOpenIcon2, 
  setIsSideNavOpenIcon3, 
  setIsSideNavOpenIcon4,
  noteDelete,
  setNoteContent,
  setChatToggle,
  chatToggle,
}) => {
  
  const [editingNote, setEditingNote] = useState(null);
  
  const handleEdit = (note) => {
    setEditingNote(note);
  };
  
  // const handleDelete = (note) => {
  //   console.log("Delete note:", note);
  //   deleteNote(note);
  // };

  // const deleteNote = async (note, skip = 0, limit = 100) => {
  //     const payLoad = {
  //       brand_id: note?.brand_id,
  //       contact_conversation_id: note?.contact_conversation_id,
  //       note_id: note?.id,
  //       page: skip,
  //       limit: limit,
  //     };
  //     const res = await deleteNote(payLoad);
  //     if (res && res?.data?.notes?.length > 0) {
  //       console.log("--------deleted response");
  //       console.log(res);
  //       // setNotes(res?.data?.notes);
  //     }
  //   };

  

  return (
    <div className="w-[20vw]">
      <div className="w-100 flex-row align-center space-between bg-white">
        <Header
          title={"Notes"}
          handleCancel={() => {
            setIsSideNavOpen(false);
            setIsSideNavOpenIcon4 && setIsSideNavOpenIcon3(false);
            setIsSideNavOpenIcon3 && setIsSideNavOpenIcon3(false);
            setIsSideNavOpenIcon2 && setIsSideNavOpenIcon2(false);
            setIsSideNavOpenIcon1 && setIsSideNavOpenIcon1(false);
            
          }}
          className="new-header"
        />
      </div>
      <div className="h-[90vh] overflow-y-auto bg-white p-4">
        {notes.length > 0 ? (
          notes.map(note => (
            <NoteCard 
              key={note.id} 
              note={note} 
              onEdit={handleEdit} 
              onDelete={() => {
                noteDelete(note)
              } }
              setNoteContent={setNoteContent}
              setChatToggle={setChatToggle}
              chatToggle={chatToggle}
            />
          ))
        ) : (
          <div className="flex items-center transition-all flex-col">
            <div className="flex flex-col items-center h-full">
              <img src={ICONS?.emptyLoader} alt="No notes" className="mb-4" />
              <p className="text-gray-500">No notes found</p>
            </div> 
            <button onClick={() => {
              setChatToggle(false);
              // setIsSideNavOpen(false);
            }} className="flex items-center text-gray-500 mt-[10px] transition-all gap-[0.5vw] hover:bg-[#F59E0B] hover:border-[#F59E0B] hover:text-white border border-gray-500 px-2 py-1 rounded cursor-pointer">
              <span className="text-[14px]">
                + Add a Note
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotesSection;
